import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-boton-primario-consulta',
  templateUrl: './boton-primario-consulta.component.html',
  styleUrls: ['./boton-primario-consulta.component.scss']
})
export class BotonPrimarioConsultaComponent {
  @Input() boton_texto: string;
  @Input() disabled: boolean = false;
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();

  ejecutarFuncion() {
    this.boton_funcion.emit();
  }
}
